import React, {useRef, useEffect, useState} from "react";
import Header from "../../components/Header";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import "./Profile.scss";
import 'mapbox-gl/dist/mapbox-gl.css';
import Footer from "../../components/Footer";
import Button from "react-bootstrap/Button";
import ProfileComponent from "../../components/Profile/ProfileComponent";

function Subscriptions() {
    return (
        <div>
            <Header/>
            <div className="container container-profile" style={{paddingTop: 86, minHeight: "100vh"}}>
                <div className="row">
                    <div className="col-md-4 mb-4">
                        <ProfileComponent/>
                    </div>
                    <div className="col-md-8 mb-4">
                        <div className="card">
                            <div className="card-body">
                                <h4>Newsletter</h4>
                                <p>Unisciti oggi alla nostra newsletter per ricevere i migliori aggiornamenti sulle
                                    nostre attività.</p>
                                <div className="d-flex justify-content-center">

                                    <Button className={"btn-orange"}>Iscriviti</Button>
                                </div>
                            </div>
                        </div>
                        <div className="card card-subscription mt-4">
                            <div className="card-body">
                                <h4>Geoticket+</h4>
                                <p>Iscriviti a Geoticket+ per ottenere la migliore esperienza dalla tua escursione!</p>
                                <div className="d-flex justify-content-center">

                                    <Button variant={"light"}>Ottieni Geoticket+</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
}

export default Subscriptions;